// extracted by mini-css-extract-plugin
export default {"status":"campaign-status_status__IzraN","active":"campaign-status_active__s1Weh","inactive":"campaign-status_inactive__cddh1","pending":"campaign-status_pending__IovI2"};